// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"7cb8b9cc","453":"cdf1c0f3"}[chunkId] + ".chunk.js";
};